<template>
  <base-survey :step="step" :question="question" :optionName="optionName" :setMethodName="setMethodName" :valueName="valueName" :total="total"
               :width="width" :height="height" type="survey_price">
  </base-survey>
</template>

<script>
  export default {
    data() {
      return {
        question: "希望する価格帯を選択してください",
        step: 2,
        setMethodName: "setPrice",
        optionName: "survey_price",
        valueName: "price",
        width: "120px",
        height: "100px",
        total: "03"
      };
    }
  };
</script>
